import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { getEventTypeForTracking } from 'crm-events-components/internal/helpers/trackingHelpers';
import TimelineCardError from 'crm-events-components/internal/eventStructure/TimelineCardError';
import TimelineErrorBoundary from 'crm-events-components/internal/error/TimelineErrorBoundary';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectPropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { getCompactEventErrorMessage } from '../../helpers/compactEventHelpers';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getRefreshUrl } from 'crm-events-components/internal/helpers/getRefreshUrl';
import { useIsEditing, PinnedEngagementIdDependency } from 'crm-events-data';
import { useActiveTaskIdContext } from 'crm-timeline-tasks/queues/context/ActiveTaskIdContext';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const dependencies = {
  pinnedEngagementId: PinnedEngagementIdDependency
};
const TimelineItemEngagement = styled.div.withConfig({
  displayName: "TimelineCard__TimelineItemEngagement",
  componentId: "ba1jra-0"
})([".draft-extend{min-height:unset;display:flex;flex-direction:column;&-editor{border-bottom:0;min-height:5rem;order:1;}&-controls{position:relative;order:2;left:0;bottom:0;}}img{max-width:100%;}.draw-controls-container{background:#f9fbfd;padding-block-start:", ";padding-block-end:", ";border-top:", " solid ", ";min-height:60px;align-items:center;display:flex;}.draw-controls-container-no-background{padding-block-start:", ";padding-block-end:", ";border-top:", " solid ", ";min-height:60px;align-items:center;display:flex;}"], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['fill-tertiary-default']);
function TimelineCard({
  isPinned,
  objectType,
  subject,
  subjectId,
  timelineItem,
  TimelineEventComponent
}) {
  const eventId = timelineItem.get('id');
  const {
    isEditing,
    setIsEditing
  } = useIsEditing(eventId);
  const timelineHasPinnedEngagement = !!useStoreDependency(dependencies.pinnedEngagementId, {
    objectType,
    subjectId
  });
  const activeTaskIdFromQuery = useActiveTaskIdContext();
  const taskId = activeTaskIdFromQuery && activeTaskIdFromQuery !== 0 ? activeTaskIdFromQuery.toString() : undefined;
  const labelIds = useMemo(() => {
    const labelIdsArray = [];
    const timestamp = timelineItem.get('timestamp');
    const id = timelineItem.getIn(['eventData', 'engagement', 'id']);
    // the expanded header title should only be read if it exists
    // which will only happen when it's in thread mode, and
    // the activity title will be read only when it exists
    // which is whenever the event is NOT in thread mode.
    if (timestamp) {
      labelIdsArray.push(`activity-title-${timestamp}`);
    } else {
      labelIdsArray.push('source-event-title');
    }
    // there is only one source event title per page
    if (id) labelIdsArray.push(`expanded-header-${id}`);
    return labelIdsArray.join(' ');
  }, [timelineItem]);
  const handleToggleEditBody = useCallback((type = 'edit engagement') => {
    CrmLogger.log('timelineEditEventInteraction', {
      action: 'Edit event',
      subAction: type,
      activity: getEventTypeForTracking(timelineItem)
    });
    setIsEditing(!isEditing);
  }, [timelineItem, setIsEditing, isEditing]);
  const eventType = timelineItem.get('etype');

  /** handle any missing etypes in CompactEventConfig */
  const defaultTimelineCardErrorMsg = () => /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "timeline.timelineCardError.default.error_jsx",
    options: {
      href: getRefreshUrl()
    },
    elements: {
      Link
    }
  });
  const getTimelineCardErrorMsg = getCompactEventErrorMessage(timelineItem) || defaultTimelineCardErrorMsg;
  return /*#__PURE__*/_jsx(TimelineErrorBoundary, {
    boundaryName: "TimelineCard_TimelineCardError",
    ErrorComponent: TimelineCardError,
    errorProps: {
      getTimelineCardErrorMsg
    },
    children: /*#__PURE__*/_jsx("article", {
      tabIndex: -1,
      "data-timeline-item": eventId,
      "aria-labelledby": labelIds,
      children: /*#__PURE__*/_jsx(TimelineItemEngagement, {
        children: /*#__PURE__*/_jsx(CardWrapper, {
          marginBlockEnd: "200",
          position: timelineHasPinnedEngagement ? 'relative' : undefined,
          compact: true,
          "data-test-id": "timeline-card",
          "data-selenium-test": "timeline-card",
          "data-selenium-event-type": eventType,
          children: /*#__PURE__*/_jsx(TimelineEventComponent, {
            isEditing: isEditing,
            isPinned: isPinned,
            objectType: objectType,
            onToggleEditBody: handleToggleEditBody,
            subject: subject,
            subjectId: subjectId,
            timelineItem: timelineItem,
            taskId: taskId
          })
        })
      })
    })
  });
}
TimelineCard.propTypes = {
  isPinned: PropTypes.bool,
  objectType: AnyCrmObjectTypePropType.isRequired,
  subject: AnyCrmObjectPropType,
  subjectId: PropTypes.string.isRequired,
  timelineItem: PropTypes.object.isRequired,
  TimelineEventComponent: PropTypes.elementType.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
TimelineCard.defaultProps = {
  isPinned: false
};
export default TimelineCard;